export default "__VITE_ASSET__BLAa43pz__"